import { Icon } from '@components';
import { useScreenSize } from '@hooks';
import { Button, Flex } from '@styles';
import { ReactComponent as PreviousIcon } from '@svgs/chevron-left.svg';
import { ReactComponent as NextIcon } from '@svgs/chevron-right.svg';
import { func, number } from 'prop-types';
import React from 'react';

const Buttons = ({ height, next, previous, width }) => {
  const { isTabletLG } = useScreenSize();

  if (isTabletLG) return null;

  return (
    <Flex gap={8}>
      <Button
        borderRadius={200}
        height={height || 48}
        onClick={previous}
        p={0}
        variant="secondary"
        width={width || 48}
      >
        <Icon SVG={PreviousIcon} />
      </Button>
      <Button
        borderRadius={200}
        height={height || 48}
        onClick={next}
        p={0}
        variant="secondary"
        width={width || 48}
      >
        <Icon SVG={NextIcon} />
      </Button>
    </Flex>
  );
};

Buttons.propTypes = {
  height: number,
  next: func.isRequired,
  previous: func.isRequired,
  width: number,
};

Buttons.defaultProps = {
  height: 0,
  width: 0,
};

export default Buttons;
